module.exports = __webpack_public_path__ + "6df9af1b9c0de549e03c568ea4e6156c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/13-dogs.svg
// module id = 73
// module chunks = 0